<template>
  <div>
    <template v-if="showHeader">
      <v-breadcrumbs class="px-0" :items="items"></v-breadcrumbs>
      <v-row class="mt-10">
        <v-col class="d-flex pt-0">
          <img
            src="../../assets/icons/sorts/resource_center.png"
            class="tcdc-resource-center-layout-icon mr-4"
          />
          <span class="text-tcdc-green bold header text-uppercase">resource center</span>
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <span class="text-tcdc-green header bold text-uppercase">{{$t('designCalendar.designCalendar')}}</span>
        </v-col>
      </v-row>
    </template>
    <v-row class="mb-10">
      <v-col>
<!--        <div class="d-flex flex-1 tcdc-calendar-search py-2">-->
        <div class="d-flex flex-1 py-2 borderbot justify-space-between">
<!--          <div class="d-flex">-->
<!--            <v-icon large color="#808080" class="mr-4">mdi-magnify</v-icon>-->
<!--          </div>-->
          <div class="d-flex align-center justify-start">
            <template  v-if="!showCalendar">
              <label class="d-flex" for="selectedDate">
                <v-icon large color="#808080" class="">mdi-magnify</v-icon>
              </label>
              <!--              <b class="my-1" @click="openCalender()">SELECT DATE</b>-->
              <button class="my-1" @click="openCalender">SELECT DATE</button>
              <!--              <template v-if="showCalendar">-->
              <!--                <DatePicker-->
              <!--                    id="selectedDateSearch"-->
              <!--                    @onPress="yearMonthHandler"-->
              <!--                    :value="selectedDate"-->
              <!--                    class="flex-shrink-1"-->
              <!--                />-->
              <!--              </template>-->


            </template>
            <template v-else>
              <label class="d-flex" for="selectedDate">
                <v-icon large color="#808080" class="">mdi-magnify</v-icon>
              </label>

              <DatePicker
                  id="selectedDate"
                  @onPress="yearMonthHandler"
                  :value="selectedDate"
                  class="flex-shrink-1"
              />

            </template>
            <v-icon v-if="has_search ==true" large color="white"  @click="clearSearch" class="mx-3" style="background-color: #999999;border-radius: 30px;font-size: 18px">mdi-close</v-icon>
            <!--            <button class="my-1" @click="openCalender">SELECT DATE</button>-->
<!--            <DatePicker-->
<!--                    @onPress="yearMonthHandler"-->
<!--                    :value="selectedDate"-->
<!--                    class="cursor-pointer" />-->
          </div>
          <div class="d-flex align-center">
            <div class="d-flex align-center">
              <span
                  class="sub-header1 bold text-tcdc-grey1 color-grey1 cursor-pointer mx-1"
                  @click="prevYear2Handler"
              > <v-icon large color="#808080" class="  " >mdi-chevron-left</v-icon>
                <!--                {{prevYearOne}}-->
              </span>
              {{current_year}}


              <span v-if="untilNextYear"
                    class="sub-header1 bold text-tcdc-grey1 color-grey1 cursor-pointer mx-1"
                    @click="prevYear1Handler"
              >
<!--              {{prevYearTwo}}-->
              <v-icon large color="#808080" class="" >mdi-chevron-right</v-icon></span>
              <span v-else    class="sub-header1 bold text-tcdc-grey1 color-white  mx-1">
                 <v-icon large color="#FFFFFF" class=""   >mdi-chevron-right</v-icon>
              </span>
            </div>
<!--            <span-->
<!--              class="sub-header1 bold text-tcdc-grey1 color-grey1 mr-4 cursor-pointer"-->
<!--              @click="prevYear1Handler"-->
<!--            >{{prevYearOne}}</span>-->
<!--            <span-->
<!--              class="sub-header1 bold text-tcdc-grey1 color-grey1 cursor-pointer"-->
<!--              @click="prevYear2Handler"-->
<!--            >{{prevYearTwo}}</span>-->
          </div>
        </div>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
<!--        <span class="bold text-tcdc-green header">{{selectedYearLang}}</span>-->
      </v-col>
    </v-row>
    <v-row>
      <template v-for="(item, index) of worldCalendar">
        <v-col cols="12" sm="6" md="4" :key="index.toString()">
          <CalendarCard
                  :name="item.name"
                  :date="item[`event_date`]"
                  :end-date="item[`end_event_date`]"
                  :location="item.location"
                  class="cursor-pointer"
                  @click.native="onOpen(item)"
          />
        </v-col>
      </template>
    </v-row>
    <v-row class="pt-8">
<!--      <v-col class="text-left">-->
<!--        <GreenButton label="previous" v-if="worldCalendarPages.prev_page_url" @onPress="changePage('prev')" />-->
<!--      </v-col>-->
<!--      <v-col class="text-right">-->
<!--        <GreenButton label="next" v-if="worldCalendarPages.next_page_url" @onPress="changePage('next')" />-->
<!--      </v-col>-->
      <v-col class="d-flex flex-1 justify-end">
        <v-pagination
                v-if="worldCalendarPages"
                v-model="worldCalendarPages.current_page"
                :length="worldCalendarPages.last_page"
                total-visible="7"
                prev-icon="mdi-menu-left"
                next-icon="mdi-menu-right"
                color="#2e8037"
                @input="changePage"
        ></v-pagination>
      </v-col>
    </v-row>
    <NotiModal
            :name="modalDetail[`name_${lang}`]"
            :routing="modalDetail.id"
            :location="modalDetail.location"
            :image="modalDetail.image"
            :visible="visible"
            @onClose="onClose"
    />
  </div>
</template>

<script>
import CalendarCard from "../../components/cards/CalendarCard";
import GreenButton from "../../components/buttons/GreenButton";
import DatePicker from "../../components/pickers/DatePicker";
import NotiModal from "../../components/modals/NotiModal";
import { mapState } from "vuex";
import moment from 'moment';
import {BreadcrumbUtil} from "@/util/BreadcrumbUtil";
import _move from "lodash-move";

export default {
  components: {
    CalendarCard,
    // GreenButton,
    DatePicker,
    NotiModal
  },
  props: {
    showHeader: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    openCalender() {
      // let temp =  document.getElementById('selectedDateSearch')
      // temp.style.display='block';
      this.showCalendar = true;
      // return this.showCalendar;
    },
    clearSearch(){
      this.has_search =false;
      this.showCalendar =false;
      window.location.reload();
    },
    onOpen(item) {
      this.modalDetail = item;
      this.visible = true;
    },
    onClose() {
      this.visible = false;
      this.modalDetail = {};
    },
    yearMonthHandler(yearMonth) {
      const arr = yearMonth.split("-");
      const year = parseInt(arr[0]);
      const month = parseInt(arr[1]);
      this.current_year = year
      this.prevYear1 = year + 1;
      this.prevYear2 = year - 1;
      this.current_year = year+543
      this.has_search = true;
      this.selectedDate = `${year} ${this.monthList[month]}`;
      const param = `${year}-${moment().month(this.monthList[month]).format('MM')}`;
      this.$store.dispatch('Program/onGetDesignWorldCalendar', { date: param, lang: this.lang });
    },
    prevYear1Handler() {
      const arr = this.selectedDate.split(" ");
      const year = parseInt(this.prevYear1);
      const month = arr[1];
      this.current_year = year
      this.prevYear1 = year + 1;
      this.prevYear2 = year - 1;
      this.current_year = year+543
      this.has_search = true;
      this.selectedDate = `${year} ${month}`;
      const param = `${year}-${moment().month(month).format('MM')}`;
      this.$store.dispatch('Program/onGetDesignWorldCalendar', { date: param, lang: this.lang });
    },
    prevYear2Handler() {
      const arr = this.selectedDate.split(" ");
      const year = parseInt(this.prevYear2);
      const month = arr[1];
      this.selectedYear = year;
      this.prevYear1 = year + 1;
      this.prevYear2 = year - 1;
      this.current_year = year+543
      this.selectedDate = `${year} ${month}`;
      const param = `${year}-${moment().month(month).format('MM')}`;
      this.$store.dispatch('Program/onGetDesignWorldCalendar', { date: param, lang: this.lang });
    },
    changePage(page) {
      let date = this.selectedDate.split(' ');
      let param = `${date[0]}-${moment().month(date[1]).format('MM')}`;
      this.$store.dispatch('Program/onGetDesignWorldCalendar', { date: param, page: page, lang: this.lang });
    }
    // changePage(mode) {
    //   let page;
    //   let date;
    //   let param;
    //   switch (mode) {
    //     case 'next':
    //       if (this.worldCalendarPages.next_page_url) {
    //         page += this.worldCalendarPages.current_page;
    //         date = this.selectedDate.split(' ');
    //         param = `${date[0]}-${moment().month(date[1]).format('MM')}`;
    //         this.$store.dispatch('Program/onGetDesignWorldCalendar', { date: param, page: page, lang: this.lang });
    //       }
    //       break;
    //
    //     case 'prev':
    //       if (this.worldCalendarPages.prev_page_url) {
    //         page -= this.worldCalendarPages.current_page;
    //         date = this.selectedDate.split(' ');
    //         param = `${date[0]}-${moment().month(date[1]).format('MM')}`;
    //         this.$store.dispatch('Program/onGetDesignWorldCalendar', { date: param, page: page, lang: this.lang });
    //       }
    //       break;
    //   }
    // }
  },
  computed: {
    ...mapState({
      branchName: state => state.Branch.branch_name,
      branchId: state => state.Branch.branch_id,
      allBranches: state => state.Branch.branches,
      lang: state => state.Branch.lang,
      worldCalendar: state => {
        if (state.Program.worldCalendar && state.Program.worldCalendar.data) {
          return state.Program.worldCalendar.data
        }
        return []
      },
      worldCalendarPages: state => state.Program.worldCalendar
    }),
    branchChanged: function () {
      return this.branchName;
    },
    prevYearOne: function () {
      if (this.lang === 'th') {
        return parseInt(this.prevYear1) + 543;
      } else {
        return this.prevYear1;
      }
    },
    prevYearTwo: function () {
      if (this.lang === 'th') {
        return parseInt(this.prevYear2) + 543;
      } else {
        return this.prevYear2;
      }
    },
    selectedYearLang: function () {
      if (this.lang === 'th') {
        return parseInt(this.selectedYear) + 543;
      } else {
        return this.selectedYear;
      }
    },
    currentYear:function (){
      if (this.lang === 'th') {
        return parseInt(this.current_year) + 543;
      } else {
        return this.current_year;
      }
    },
    untilNextYear: function () {
      if ((this.current_year - 543) != new Date().getFullYear()) {
        return true
      }
      for (const x of this.worldCalendar) {
        // get end date year
        if (x.end_event_date_en && x.end_event_date_en.split(' ')[2] > (this.current_year - 543)) {
          return true
        }
      }
      return false
    }
  },
  watch: {
    branchChanged: function() {
      this.items = BreadcrumbUtil.setServiceItem(
          this.items,
          this.branchId,
          this.branchName,
          this.allBranches,
          this.lang
      )
    }
  },
  data: () => ({
    showCalendar:false,
    has_search:false,
    current_year:'',
    eventSortType: 'date',
    isLoading: false,
    move: _move,
    year_next:"",
    selectedDate: "",
    selectedYear: "",
    prevYear1: "",
    prevYear2: "",
    visible: false,
    modalDetail: {},
    blank_text:" ",
    items: [
      {
        text: 'TCDC BANGKOK',
        disabled: false,
        to: "/home/:branch"
      },
      {
        text: "SERVICE",
        disabled: false,
        to: "/:branch/service"
      },
      {
        text: "RESOURCE CENTER",
        href: "/:branch/service/resource-center"
      },
      {
        text: "DESIGN WORLD CALENDAR",
        disabled: true,
      }
    ],
    columnHeight: "350px",
    monthList: [
      "",
      "JANUARY",
      "FEBUARY",
      "MARCH",
      "APRIL",
      "MAY",
      "JUNE",
      "JULY",
      "AUGUST",
      "SEPTEMBER",
      "OCTOBER",
      "NOVEMBER",
      "DECEMBER"
    ]
  }),
  created() {
    const date = new Date();
    this.items = BreadcrumbUtil.setServiceItem(
        this.items,
        this.branchId,
        this.branchName,
        this.allBranches,
        this.lang
    )
    // const currentMonth = parseInt(date.getMonth()) + 1;
    // const currentYear = date.getFullYear();
    const currentMonth = parseInt(date.getMonth()) + 1;
    const currentYear = date.getFullYear();
    this.prevYear1 = currentYear + 1;
    this.prevYear2 = currentYear - 1;
    this.current_year = currentYear+543
    this.year_next = (currentYear+543)
    this.selectedDate = `${currentYear} ${this.monthList[currentMonth]}`;
    const param = `${currentYear}-${moment().month(this.monthList[currentMonth]).format('MM')}`;
    this.$store.dispatch('Program/onGetDesignWorldCalendar', { date: param, lang: this.lang });
  }
};
</script>

<style lang="scss" scoped>
.tcdc-calendar-search {
  border-bottom: 2px solid $tcdcGrey1;
}
</style>
